import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login'
import main from '@/components/main'
import part from '@/components/part'
import partGroup from '@/components/partGroup'
import houseProject from '@/components/houseProject'
import frimTag from '@/components/frimTag'
import partTag from '@/components/partTag'
import styleTag from '@/components/styleTag'
import shapeTag from '@/components/shapeTag'
import brandTag from '@/components/brandTag'
import seriesTag from '@/components/seriesTag'
import seriesType from '@/components/seriesType'
import fixtureTag from '@/components/fixtureTag'
import sizeType from '@/components/sizeType'
import accountAdmin from '@/components/accountAdmin'
import userAdmin from '@/components/userAdmin'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/main',
      name: 'main',
      component: main
    },
    {
      path: '/part',
      name: 'part',
      component: part
    },
    {
      path: '/partGroup',
      name: 'partGroup',
      component: partGroup
    },
    {
      path: '/houseProject',
      name: 'houseProject',
      component: houseProject
    },
    {
      path: '/frimTag',
      name: 'frimTag',
      component: frimTag
    },
    {
      path: '/partTag',
      name: 'partTag',
      component: partTag
    },    
    {
      path: '/styleTag',
      name: 'styleTag',
      component: styleTag
    },
    {
      path: '/shapeTag',
      name: 'shapeTag',
      component: shapeTag
    },
    {
      path: '/brandTag',
      name: 'brandTag',
      component: brandTag
    },
    {
      path: '/seriesTag',
      name: 'seriesTag',
      component: seriesTag
    },
    {
      path: '/seriesType',
      name: 'seriesType',
      component: seriesType
    },
    {
      path: '/fixtureTag',
      name: 'fixtureTag',
      component: fixtureTag
    },
    {
      path: '/sizeType',
      name: 'sizeType',
      component: sizeType
    },
    {
      path: '/accountAdmin',
      name: 'accountAdmin',
      component: accountAdmin
    },
    {
      path: '/userAdmin',
      name: 'userAdmin',
      component: userAdmin
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js